import React, { ReactElement } from "react";
import { Stack, Text } from "sprint-common-web";

type ShreqVersionReference = {
    id: string;
    name: string;
};

export const renderShreqVersionItem = (props: ShreqVersionReference | undefined): ReactElement | null => {
    if (!props) {
        return null;
    }

    return (
        <Stack>
            <Stack verticalAlign="center">
                <Text value={`Id: ${props.id}`} styles={{ root: { fontSize: 12 } }} />
            </Stack>
            <Stack verticalAlign="center">
                <Text value={`Name: ${props.name}`} styles={{ root: { fontSize: 12 } }} />
            </Stack>
        </Stack>
    );
};
